
import { jsPDF } from "jspdf";
import { PdfSectionOptions } from "../types";

/**
 * Add introduction section
 */
export const addIntroduction = ({ doc, pageWidth, y }: PdfSectionOptions): number => {
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.text("Introduction", 15, y);
  
  doc.setDrawColor(200, 200, 200);
  doc.line(15, y + 5, pageWidth - 15, y + 5);
  
  doc.setFontSize(11);
  const introText = 
    "As artificial intelligence becomes increasingly integrated into business operations, boards face new " +
    "challenges in overseeing AI's strategic, ethical, and risk implications. Effective AI governance at the " +
    "board level is critical to ensuring responsible use of these technologies while maximizing their benefits.\n\n" +
    "This report evaluates your board's current readiness to provide AI governance oversight, based on " +
    "your responses to our assessment questionnaire. It identifies your strengths, highlights areas for " +
    "improvement, and provides actionable recommendations to enhance your board's AI governance capabilities.";
  
  const introLines = doc.splitTextToSize(introText, pageWidth - 30);
  doc.text(introLines, 15, y + 15);
  
  return y + 15 + (introLines.length * 5) + 10;
};
